import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, moneyFormat } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "currency",
		headerName: "Currency",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "--",
	},
	{
		field: "buyRate",
		headerName: "Buy Rate",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	{
		field: "sellRate",
		headerName: "Sell Rate",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	
	...createdAtmodifiedAtActions
];
